import { c as _c } from "react/compiler-runtime";
import { SwitchWithLabel } from '@newfront-insurance/core-ui';
import { useChatOverlayContext } from '../chat-v2/contexts/chat-overlay-context';

/**
 * Composable toggle primitive for MS Graph (Outlook Connect) enable/disable.
 * Reads and writes outlookConnectEnabled from ChatOverlayContext.
 * The underlying auth flow is handled by useOutlookConnectController in NovaProvider.
 *
 * @example
 * <MSGraphSectionHeader>
 *   <h3>Outlook Connect</h3>
 *   <MSGraphToggle />
 * </MSGraphSectionHeader>
 */
export function MSGraphToggle() {
  const $ = _c(6);
  const {
    outlookConnectEnabled,
    setOutlookConnectEnabled
  } = useChatOverlayContext();
  let t0;
  if ($[0] !== outlookConnectEnabled || $[1] !== setOutlookConnectEnabled) {
    t0 = () => setOutlookConnectEnabled(!outlookConnectEnabled);
    $[0] = outlookConnectEnabled;
    $[1] = setOutlookConnectEnabled;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== outlookConnectEnabled || $[4] !== t0) {
    t1 = <SwitchWithLabel label="" enabled={outlookConnectEnabled} onClick={t0} locked={false} labelPosition="left" />;
    $[3] = outlookConnectEnabled;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}